
import { mapGetters } from 'vuex';
export default {


    computed: {
        options() {
            return {
                shortcuts: [
                    {text: this.$t("global.common.latest_week",{defaultValue:'最近一周'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    },
                    {text: this.$t("global.common.recent_month",{defaultValue:'最近一月'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    },
                    {text: this.$t("global.common.latest_quarter",{defaultValue:'最近一季度'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }
                ]
            }
        },
        /**
         * 单据状态
         *
         */
        getBillStatus() {
            // DRAFT(0, "草稿"),
            // UNCHECK(5, "待审核"),
            // CHECK_REFUSED(6,"审核拒回"),
            // UN_BOXED(8, "待装箱"),
            // UNSHIPPED(10, "待发货"),
            // UNRECEIVED(15, "待接收"),
            // UNSTOCKIN(20, "待入库"),
            // INBOUNDING(25, "入库中"),
            // COMPLETED(70, "已完成"),
            // CLOSED(90, "已关闭"),
            // CANCELED(100,"已取消");
            return [{
                label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),
                value: '0',
            }, {
                label: this.$t('fbb.inbound.check_pending', { defaultValue: '待审核' }),
                value: '5',
                theme: 'primary'
            }, {
                label: this.$t('fbb.inbound.approval_back', { defaultValue: '审批拒回' }),
                value: '6',
                theme: 'error'
            }, {
                label: this.$t('fbb.inbound.for_packing', { defaultValue: '待装箱' }),
                value: '8',
            }, {
                label: this.$t('fbb.inbound.send_goods', { defaultValue: '待发货' }),
                value: '10',
                theme: 'info'
            }, {
                label: this.$t('fbb.inbound.stock_pending', { defaultValue: '待入库' }),
                value: '20',
                theme: 'warning'
            }, {
                label: this.$t('fbb.inbound.inthe_library', { defaultValue: '入库中' }),
                value: '25',
            }, {
                label: this.$t('global.common.finished', { defaultValue: '已完成' }),
                value: '70',
                theme: 'success'
            }, {
                label: this.$t('global.common.canceled', { defaultValue: '已取消' }),
                value: '100',
                theme: 'error'
            }]
        },
        /**
         * 库存类型
         */
        getInventoryType() {
            return [
                { value: 0, label: this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }) },
                { value: 1, label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }) },
            ]
        },

        /**
         * 货物形态
         */
        getGoodsType() {
            //             CONTAINER_CARTON(2,"集装箱+纸箱"),
            // CARTON(4,"卡车+纸箱"),
            // CARTON_OTHER(5,"卡车+散货"),
            // OTHER(6,"集装箱+散货");

            //1:集装箱+纸箱 2:卡车+纸箱 3:集装箱+托盘 4:卡车+托盘 5:散货
            return [
                { value: 2, label: this.$t('fbb.inbound.container', { defaultValue: '集装箱' }) },
                { value: 4, label: this.$t('fbb.inbound.truck', { defaultValue: '卡车' }) },
                { value: 5, label: this.$t('fbb.headlogistics.express', { defaultValue: '快递' })}
                // { value: 3, label: '集装箱+托盘' },
                // { value: 4, label: '卡车+托盘' },
                // { value: 5, label: '卡车+散货' },
                // { value: 6, label: '集装箱+散货' },
            ]
        },
        /**
         * 入库单号状态
         */
        getOrderStatus() {
            // DRAFT(0,"草稿"),
            // COMPLETED(70,"已完成"),
            // CLOSED(90,"已关闭");
            return [
                { value: 0, label: this.$t('fbb.inbound.draft', { defaultValue: '草稿' }) },
                { value: 70, label: this.$t('global.common.confirmed', { defaultValue: '已确认' }), theme: 'success' },
                { value: 90, label: this.$t('global.common.canceled', { defaultValue: '已取消' }), theme: 'error' },
            ]
        },
        getAbnormalType() {
            return [
                {
                    label: this.$t('fbb.inbound.error_push', { defaultValue: "推送异常" }),
                    value: 0
                }, {
                    label: this.$t('fbb.inbound.error_receive', { defaultValue: "回传异常" }),
                    value: 1
                }, {
                    label: this.$t('fbb.inbound.error_cancel', { defaultValue: "取消异常" }),
                    value: 2
                }, {
                    label: this.$t('fbb.inbound.error_approve', { defaultValue: "审核异常" }),
                    value: 5
                },
                {
                    label: this.$t('fbb.inbound.error_complete', { defaultValue: "完成异常" }),
                    value: 6
                },
                {
                    label: this.$t('fbb.inbound.error_shipping', { defaultValue: "发运异常" }),
                    value: 7
                },
                {
                    label: this.$t('fbb.inbound.error_wms_create', { defaultValue: "wms单据创建异常" }),
                    value: 8
                },{
                    label: this.$t('fbb.inbound.error_wms_complete', { defaultValue: "wms单据完成异常" }),
                    value: 9
                },
                {
                    label: this.$t('fbb.inbound.error_attachment_push', { defaultValue: "附件推送异常" }),
                    value: 11
                },
            ]
        },
        getLogActions () {
            return {
                4: this.$t('fbb.inbound.common_tracking_to_boss', { defaultValue: 'tracking回写Boss' }),
                10: this.$t('fbb.inbound.common_push_attachment', { defaultValue: '推送附件' }),
                13: this.$t('fbb.inbound.common_stock_rewrite', { defaultValue: '库存流水回写' }),
                90: this.$t('fbb.inbound.common_lose_efficacy', { defaultValue: '失效' }),
                96: this.$t('fbb.inbound.common_fba_data_import', { defaultValue: 'FBA箱数据导入' }),
                100: this.$t('global.common.create', { defaultValue: '创建' }),
                150: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                200: this.$t('fbb.inbound.common_update', { defaultValue: '更新' }),
                210: this.$t('global.common.operation_submit', { defaultValue: '提交' }),
                220: this.$t('fbb.inbound.common_shipping', { defaultValue: '发运' }),
                230: this.$t('fbb.inbound.common_save_and_commit', { defaultValue: '保存并提交' }),
                240: this.$t('fbb.inbound.common_widthdraw_reply', { defaultValue: '撤回申请' }),
                250: this.$t('global.common.save', { defaultValue: '保存' }),
                260: this.$t('global.common.edit', { defaultValue: '编辑' }),
                290: this.$t('fbb.inbound.common_unloading', { defaultValue: '卸货' }),
                300: this.$t('global.common.delete', { defaultValue: '删除' }),
                400: this.$t('global.common.cancel', { defaultValue: '取消' }),
                500: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                560: this.$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' }),
                600: this.$t('fbb.inbound.common_audit_rejection', { defaultValue: '审核拒绝' }),
                610: this.$t('fbb.inbound.common_boss_handle', { defaultValue: 'BOSS处理' }),
                620: this.$t('fbb.inbound.common_file_export', { defaultValue: '文件导出' }),
                700: this.$t('fbb.inbound.audit', { defaultValue: '审核' }),
                710: this.$t('fbb.inbound.common_outbound', { defaultValue: '已出库' }),
                720: this.$t('global.common.confirmed', { defaultValue: '已确认' }),
                800: this.$t('global.common.finish', { defaultValue: '完成' }),
                830: this.$t('fbb.inbound.rawcrates_standard', { defaultValue: '生成箱标' }),
                840: this.$t('fbb.inbound.common_operate_change_warehouse', { defaultValue: '换仓操作' }),
                930: this.$t('fbb.inbound.common_push_warehouse', { defaultValue: '推送仓库' }),
                1010: this.$t('fbb.inbound.common_notice_boss', { defaultValue: '调拨入库执行单回传boss' }),
                1020: this.$t('fbb.inbound.click_packing', { defaultValue: '一键装箱' }),
                1030: this.$t('fbb.inbound.confirm_delivery', { defaultValue: '确认发货' }),
                1031: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                1040: this.$t('fbb.inbound.common_purchase_notice', { defaultValue: '采购入库执行单回传' }),
                1046: this.$t('fbb.inbound.common_confirm_reach_warehouse', { defaultValue: '确认到仓' }),
                1050: this.$t('fbb.inbound.common_confirm_push_boss', { defaultValue: '发运确认推送boss' }),
                1060: this.$t('fbb.inbound.common_audit_push_boss', { defaultValue: '审核通过推送boss' }),
                1070: this.$t('fbb.inbound.common_refuse_push_boss', { defaultValue: '审核退回推送boss' }),
                1047: this.$t('fbb.inbound.port_confirm', { defaultValue: '到港确认' }),
                1073:this.$t('fbb.inbound.common_warehouse_rewrite', { defaultValue: '仓库回写' }),
                1090:this.$t('fbb.headlogistics.shangchuanfapiao', { defaultValue: '上传发票' })
            }
        },
        // ...mapGetters('common', ['getLogActions'])
    }
}
